import React from 'react';

export const Ingestion = React.lazy(() => import('./Ingestion'));
export * from './IngestionNavMenu';
